import React from 'react';
import { Box, Typography } from '@material-ui/core';
import { GridFooterContainer, GridPagination } from '@material-ui/data-grid';

export default function QCXDataGridTotalFooter({ label }) {
  return (
    <GridFooterContainer>
      <Box pl={2}>{label && <Typography variant="body2">{label}</Typography>}</Box>
      <GridPagination />
    </GridFooterContainer>
  );
}
